<template>
    <BaseInfoDetail>
      <dl class="fee-estimate">
        <div class="term-group">
          <dt>Registration fee estimate</dt>
          <dd>{{ estimate }}</dd>
        </div>
      </dl>
    </BaseInfoDetail>
</template>

<script>
import { mapGetters } from 'vuex'
import { toCurrency } from '@/utils/helpers'
import * as COMMONS from '../../../store/_commons'
import BaseInfoDetail from '../../ui/BaseInfoDetail'


export default {
  name: "EstimateFee",
  components: {
    BaseInfoDetail,
  },
  computed: {
    ...mapGetters({
      quoteEstimateInfo: COMMONS.QUOTE_ESTIMATE_INFO,
    }),
    estimate() {
      return toCurrency(this.quoteEstimateInfo.registrationFee);
    },
  },
}
</script>

<style lang="scss" scoped>
.fee-estimate {
  width: 100%;
  .term-group {
    display: flex;
    flex-wrap: wrap;
    gap: 1em;
    justify-content: space-between;
  }
}
</style>
